import React from 'react';
import { stackItems } from '../data/content';
import { Reveal } from './showcase/Reveal';
export function StackSection() {
  return <section id="stack" aria-labelledby="stack-title" className="border-b border-white/5 bg-ink-900" data-id="element-473" data-mp="jej1sxxu8bqy">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-474" data-mp="5fjcrp6exuu9">
        <Reveal data-id="element-475" data-mp="act8fmkeb2qj">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-476" data-mp="aeduensn9dcs">
            Integrations
          </p>
          <h2 id="stack-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-477" data-mp="1237jlb10y0yi">
            Works with your stack.
          </h2>
        </Reveal>

        <ul className="mt-10 flex flex-wrap gap-3" data-id="element-478" data-mp="t9uelapor8w2">
          {stackItems.map((item, index) => <li key={item} data-id="element-479" data-mp="1gzyb6y4gi8dk" data-mpi={index}>
              <Reveal delay={0.04 * index} offset={10} data-id="element-480" data-mp="1gyn8l1mqz6o1">
                <span className="inline-block rounded-lg border border-white/10 bg-ink-800 px-4 py-2.5 text-sm font-medium text-white/75" data-id="element-481" data-mp="1lshvedxng1rc">
                  {item}
                </span>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.1} className="mt-8 max-w-2xl" data-id="element-482" data-mp="1pqwmv9lo6401">
          <p className="text-base leading-relaxed text-white/60" data-id="element-483" data-mp="23kw7q5fvkl4u">
            Keep what you have. Your CRM stays the source of truth. Agents never log into a
            second system.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-10 max-w-2xl border-l-2 border-brand pl-5" data-id="element-484" data-mp="2dgh51qa00x89">
          <p className="font-display text-lg leading-relaxed text-white/85 sm:text-xl" data-id="element-485" data-mp="28ipccu1j5730">
            If you have already turned off an AI chatbot, good. Most of them deserve it.
          </p>
        </Reveal>
      </div>
    </section>;
}